import React from "react";
import GreenCardNum from "./../../../partials/GreenCardNum/GreenCardNum";
import { getLeagueTable } from '../../../api/getLeagueTable';

import styles from "./LeagueScoreTable.module.css";
import { useParams } from "react-router-dom";

function LeagueScoreTable() {
  const { leagueId } = useParams();
  const [scores, setScores] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    getLeagueTable(leagueId).then((data) => {
      setScores(data);
      setIsLoading(false);
    });
  }, [leagueId]);

  return (
    <div className={styles.leagueScoreTable}>
      <div className="collapsBtn">טבלת הליגה</div>
      <div className={`${styles.tableRow} ${styles.tableTopic}`}>
        <div>-</div>
        <div>קבוצה</div>
        <div>מש'</div>
        <div>נצ'</div>
        <div>תק'</div>
        <div>הפ'</div>
        <div>שע'</div>
        <div>נק'</div>
        <div> </div>
      </div>

      {isLoading ? (
        <div>הנתונים בטעינה ...</div>
      ) : (
        scores.map((score, index) => (
          <div
            key={score.id}
            className={`${styles.tableRow} ${
              index % 2 === 0 ? styles.odd : styles.even
            }`}
          >
            <div>{index + 1}</div>
            <div>{score.name}</div>
            <div>{score.games_count}</div>
            <div>{score.wins}</div>
            <div>{score.draws}</div>
            <div>{score.losses}</div>
            <div>{score.goals}</div>
            <div className={styles.score}>{score.points}</div>
            <div className={styles.greenCardDiv}>
              <GreenCardNum num={score.green_cards} />
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default LeagueScoreTable;
